
import { Suspense } from 'react';
import { BrowserRouter, useRoutes, useLocation } from 'react-router-dom';
import routes from './router/config';
import { AuthProvider } from './components/feature/AuthProvider';
import { ProtectedRoute } from './components/feature/ProtectedRoute';

function AppContent() {
  const element = useRoutes(routes);
  const location = useLocation();
  
  // Routes that don't need authentication
  const publicRoutes = ['/login'];
  const isPublicRoute = publicRoutes.includes(location.pathname);
  
  return (
    <Suspense fallback={
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-loader-4-line text-blue-600 text-2xl animate-spin"></i>
          </div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    }>
      {isPublicRoute ? (
        element
      ) : (
        <ProtectedRoute>
          {element}
        </ProtectedRoute>
      )}
    </Suspense>
  );
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
